var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header"}},[_c('div',[(_vm.loggedIn)?_c('Navigation',{staticStyle:{"width":"340px"}}):_vm._e(),_c('img',{attrs:{"src":require("@/assets/logo.png")}})],1),(_vm.loggedIn)?_c('h3',[_vm._v(" "+_vm._s(_vm.name)+" / System: "+_vm._s(_vm.usedStack)+" ")]):_vm._e(),(_vm.loggedIn)?_c('MessengerToggle'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }